export default import.meta.ROLLDOWN_FILE_URL_fJtBESR6gf81ETa80lSrgQ